import React from 'react';
import { Alert } from 'antd';
import { AlertProps } from 'antd/lib/alert';
import classnames from 'classnames';
import styles from './Banner.module.less';

const Banner = (props: AlertProps) => {
  const { className, ...rest } = props;
  return <Alert {...rest} className={classnames([styles.alertBanner, className])} />;
};

export default Banner;
